import CheckIcon from '@mui/icons-material/Check';
import { Box, Button, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { translations } from 'locales/i18n';

interface Props {
  Payment: boolean;
  hideButton: boolean;
}

export default function PricingSlot(props: Props) {
  const { t } = useTranslation();
  return (
    <Grid container direction="column">
      <Card variant="elevation" className="pricing-table__cardstyle" sx={{ boxShadow: 8 }}>
        <CardHeader
          title={
            props.Payment
              ? t(translations.pages.pricingslots.payTitle())
              : t(translations.pages.pricingslots.freeTitle())
          }
          titleTypographyProps={{ className: 'pricing-table__cardtitle' }}
          sx={{ boxShadow: 4 }}
          subheader={t(translations.pages.pricingslots.subheader())}
          subheaderTypographyProps={{ className: 'pricing-table__cardsubtitle' }}
        ></CardHeader>
        <CardContent>
          <Box px={2}>
            <Box px={3}>
              <Typography variant="h3" component="h2" gutterBottom={true} color="primary">
                {props.Payment
                  ? t(translations.pages.pricingslots.payPrice())
                  : t(translations.pages.pricingslots.freePrice())}
                <Typography variant="h6" color="textSecondary" component="span">
                  {t(translations.pages.pricingslots.suffix())}
                </Typography>
              </Typography>
            </Box>

            <Typography color="textSecondary" variant="subtitle1">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit1())}
            </Typography>
            <Typography color="textSecondary" variant="subtitle1" component="p">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit2())}
            </Typography>
            <Typography color="textSecondary" variant="subtitle1" component="p">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit3())}
            </Typography>
            <Typography color="textSecondary" variant="subtitle1" component="p">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit4())}
            </Typography>
            <Typography color="textSecondary" variant="subtitle1" component="p">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit5())}
            </Typography>
            <Typography color="textSecondary" variant="subtitle1" component="p">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit6())}
            </Typography>
            <Typography color="textSecondary" variant="subtitle1" component="p">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit7())}
            </Typography>
            <Typography color="textSecondary" variant="subtitle1" component="p">
              <CheckIcon fontSize="small" /> &nbsp;
              {t(translations.pages.pricingslots.freeBenefit8())}
            </Typography>
            {props.Payment && (
              <>
                <Typography color="primary" variant="subtitle1" component="p">
                  <CheckIcon /> &nbsp;
                  {t(translations.pages.pricingslots.payBenefit1())}
                </Typography>
                <Typography color="primary" variant="subtitle1" component="p">
                  <CheckIcon /> &nbsp;
                  {t(translations.pages.pricingslots.payBenefit2())}
                </Typography>
                <Typography color="primary" variant="subtitle1" component="p" paragraph={true}>
                  <CheckIcon /> &nbsp;
                  {t(translations.pages.pricingslots.payBenefit3())}
                </Typography>
              </>
            )}
          </Box>
          {props.hideButton ? (
            <Grid />
          ) : (
            <Grid container justifyContent="center" className={'pricing-table__button'}>
              <Link to={'../login?view=company-register'}>
                <Button variant="contained" color="primary" sx={{ boxShadow: 2, color: 'white' }}>
                  {t(translations.pages.pricingslots.buttontext())}
                </Button>
              </Link>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}
